
import { computed, defineComponent, ref } from "vue";
import { useRoute } from "vue-router";
import Header from "@/views/sms/components/detail/Header.vue";
import Content from "@/views/sms/components/detail/Content.vue";
import { ISms } from "@/interfaces/iSms";

export default defineComponent({
  name: "private-chat",
  components: {
    Header,
    Content,
  },
  props: {
    selectedData: {
      type: Array as () => Array<ISms>,
      required: true,
    },
    taskName: {
      type: Array as any,
      required: false,
    },
  },
  setup() {
    const route = useRoute();
    const searchTerm = ref<string>("");
    const conversationId = computed(() => {
      return route?.params?.id?.toString() || 0;
    });
    const searchMessage = (search: string) => {
      searchTerm.value = search;
    };
    return {
      searchTerm,
      conversationId,
      searchMessage,
    };
  },
});
